import { AccountType } from '@mnz-core/models/_enums';
import { ICredentials } from '@mnz-modules/login/models/credentials';
import { createAction, props } from '@ngrx/store';
import { ILogin } from '@mnz-modules/login/models/login';
import { IMessage } from '@mnz-core/models/message';
import { ISAMLRequest } from '@mnz-modules/login/models/saml-request';
import { ISAMLResponse } from '@mnz-modules/login/models/saml-response';

export const resetState = createAction('[Auth] Reset State');

export const authenticate = createAction(
  '[Auth] Authenticate',
  props<{ credentials: ICredentials; accountType: AccountType; captcha: string }>()
);

export const authenticateFail = createAction('[Auth] Authenticate Fail', props<{ message?: IMessage }>());

export const resetFailMessage = createAction('[Auth] Reset Fail Message');

export const authenticateSuccess = createAction('[Auth] Authenticate Success', props<{ login: ILogin }>());
export const setUserInput = createAction('[Auth] Set User Input', props<{ userInput: string }>());
export const setLoading = createAction('[Auth] Set loading', props<{ loading: boolean }>());

export const logout = createAction('[Auth] Logout');
export const logoutFail = createAction('[Auth] Logout Fail', props<{ message?: IMessage }>());
export const logoutSuccess = createAction('[Auth] Logout Success');

export const refreshToken = createAction('[Auth] Refresh token');
export const refreshTokenSuccess = createAction('[Auth] Refresh token success', props<{ login: ILogin }>());
export const refreshTokenFail = createAction('[Auth] Refresh token fail', props<{ message?: IMessage }>());

export const doSamlLogin = createAction('[Auth] doSamlLogin', props<{ samlRequest: ISAMLRequest, credentials: ICredentials, captcha: string }>());
export const samlLoginSuccess= createAction('[Auth] samlLoginSuccess', props<{ samlResponse: ISAMLResponse }>());
